export const ADDRESS_DETAIL_TEXTS = {
    MAIN_TITLE: "Tu dirección en Miami para",
    TERMS_CONDITIONS_TEXT: "Revisa los ",
    TERMS_CONDITIONS_TEXT2: "términos, condiciones, tarifas e instrucciones de uso aquí",
    DOUBTS_TEXT: "─── ¿Tienes dudas?,",
    CONTACT_US_TEXT: "Contáctanos",
    OPTIONS: {
        APPLE: {
            NAME: "apple",
            TEXT: "Dirección residencial",
            MESSAGE: (
                <>
                    <p className="message-text-default">Envía tus compras de
                        <span className="message-text-color"> Apple, BestBuy, Walmart, Nike, StockX, Steam,</span> o cualquier pedido que sepas que podrían despachar por
                        <span className="message-text-color"> USPS, </span> a esta dirección. 
                        Es ideal para este tipo de envíos.
                         <br></br>
                         <br></br>
                         Ten en cuenta que, si usas las
                        <span className="message-text-color"> otras direcciones</span>, algunos de estos comercios<span className="message-text-color"> podrían rechazar tus pedidos al detectar que son direcciones comerciales.</span>
                        </p>
                    <p className='message-text-default'>Recuerda que debes programar tus entregas de Lunes a Viernes de 9:00am a 3:30pm</p>
                </>
            ),
            ADDRESS: {
                DIRECCION: "10185 Collins AVE",
                APTO: "Apto 715",
                ESTADO: "Florida - FL",
                CIUDAD: "Bal Harbour",
                CODIGO_POSTAL: "33154"
            }
        },
        EXPRESS: {
            NAME: "express",
            TEXT: "Compras Menores a 200 USD Express",
            MESSAGE: (
                <>
                    <p className="message-text-default">Así es, en <span className="message-text-color">96 horas hábiles</span> ponemos
                        tus compras en la puerta de tu casa. </p>
                    <p className='message-text-default'>No olvides que sólo podrás enviar <span className="message-text-color">hasta 6 unidades </span>
                    del mismo producto.</p>
                    <p className='message-text-default'>Recuerda debes programar tus entregas de Lunes a Viernes de 9:00am a 3:30pm.</p>
                </>
            ),
            ADDRESS: {
                DIRECCION: "2120 NW 96TH AVE",
                ESTADO: "Florida - FL",
                CIUDAD: "Doral",
                CODIGO_POSTAL: "33172-2325"
            }
        },
        MAJOR: {
            NAME: "major",
            TEXT: "Compras Mayores a 200 USD",
            MESSAGE: (
                <>
                    <p className='message-text-default'>A esta dirección puedes enviar <span className="message-text-color">las cantidades
                        que quieras y los productos que quieras</span> menos juguetes bélicos, de resto, lo que seaaaa.</p>
                    <p className='message-text-default'>Recuerda que debes programar tus entregas de Lunes a Viernes de 9:00am a 3:30pm.</p>
                </>
            ),
            ADDRESS: {
                DIRECCION: "10900 NW 21ST. ST220",
                APTO: "Suite #220",
                ESTADO: "Florida - FL",
                CIUDAD: "Miami",
                CODIGO_POSTAL: "33172-2006"
            }
        },
        MINOR: {
            NAME: "minor",
            TEXT: "Compras Menores a 200 USD",
            MESSAGE: (
                <>
                    <p className='message-text-default'>No olvides que solo podrás
                        enviar <span className="message-text-color">hasta 6 unidades</span> del mismo producto.</p>
                    <p className='message-text-default'>Recuerda que debes programar tus entregas de Lunes a Viernes de 9:00am a 3:30pm.</p>
                </>
            ),
            ADDRESS: {
                DIRECCION: "10900 NW 21ST. ST220",
                APTO: "Suite #220",
                ESTADO: "Florida - FL",
                CIUDAD: "Miami",
                CODIGO_POSTAL: "33172-2006"
            }
        }
    }
};